import getApiService from 'modules/api/services/get'
import setReduxAction from 'modules/redux/actions/set'
import {
  TRAINING_APP_ACTION,
  TRAINING_APP_DOMAIN,
  TRAINING_APP_PATH
} from 'modules/training/modules/app/constants'
import setIsConnectedNetworkAction from 'modules/training/modules/network/actions/set-is-connected'
import { NETWORK_ENDPOINT } from 'modules/training/modules/network/constants'
import { joinPathsStringUtil } from 'utils/string'
import { joinUpperCaseUnderscoreStringUtil, getObjectUtil } from 'packages/src'

const CHECK_CONNECTED_TIMEOUT = 30000
let timerId

function fetchIsConnectedNetworkAction () {
  return async (dispatch) => {
    if (timerId) {
      clearTimeout(timerId)
    }
    try {
      const response = await getApiService(`${TRAINING_API_ENDPOINT}${NETWORK_ENDPOINT.HEALTHCHECK}`)
      timerId = setTimeout(() => {
        dispatch(fetchIsConnectedNetworkAction())
      }, CHECK_CONNECTED_TIMEOUT)
      dispatch(setIsConnectedNetworkAction(true))
      const systemData = getObjectUtil(response, 'data') || {}
      Object.keys(systemData).forEach(key => {
        dispatch(setReduxAction({
          type: joinUpperCaseUnderscoreStringUtil(TRAINING_APP_ACTION.UPDATE_SYSTEM, key),
          payload: {
            value: systemData[key],
            path: joinPathsStringUtil(TRAINING_APP_DOMAIN, key)
          }
        }))
      })
      const checkingIos = getObjectUtil(response, 'data.checkingIos')
      if (typeof checkingIos !== 'undefined') {
        dispatch(
          setReduxAction({
            type: checkingIos
              ? TRAINING_APP_ACTION.UPDATE_IS_CHECKING_IOS
              : TRAINING_APP_ACTION.RESET_IS_CHECKING_IOS,
            payload: {
              value: checkingIos,
              path: TRAINING_APP_PATH.IS_CHECKING_IOS
            }
          })
        )
      }
      const checkingAndroid = getObjectUtil(response, 'data.checkingAndroid')
      if (typeof checkingAndroid !== 'undefined') {
        dispatch(
          setReduxAction({
            type: checkingAndroid
              ? TRAINING_APP_ACTION.UPDATE_IS_CHECKING_ANDROID
              : TRAINING_APP_ACTION.RESET_IS_CHECKING_ANDROID,
            payload: {
              value: checkingAndroid,
              path: TRAINING_APP_PATH.IS_CHECKING_ANDROID
            }
          })
        )
      }
    } catch (error) {
      console.error('[fetchIsConnectedNetworkAction] failed: ', error)
      dispatch(setIsConnectedNetworkAction(false))
      timerId = setTimeout(() => {
        dispatch(fetchIsConnectedNetworkAction())
      }, CHECK_CONNECTED_TIMEOUT)
    }
  }
}

export default fetchIsConnectedNetworkAction
